"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EmployerSelectorWithHistory = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../../../utils");
var _EmployerDropdown = require("../../EmployerDropdown");
var _PatientEmployerRelationsDetails = _interopRequireDefault(require("../../PatientEmployerRelationsDetails"));
var _ = require("../../..");
var _utils2 = require("./utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var EmployerSelectorWithHistory = function EmployerSelectorWithHistory(_ref) {
  var patient = _ref.patient;
  var _useRequest = (0, _utils.useRequest)((0, _utils.getPatientEmployerRelationsUrl)(patient.id), {
      refreshDeps: [patient.id]
    }),
    patientEmployerRelations = _useRequest.data,
    patientEmployerRelationsLoading = _useRequest.loading,
    refetchEmployerRelations = _useRequest.refresh;
  var currentEmployerRelation = (0, _utils2.getCurrentEmployerRelation)(patientEmployerRelations);
  if (patientEmployerRelationsLoading) {
    return /*#__PURE__*/_react.default.createElement(_.SpinPlaceholder, null);
  }
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_EmployerDropdown.EmployerDropdown, {
    patient: patient,
    selectedRelation: currentEmployerRelation,
    onUpdateSuccess: refetchEmployerRelations
  }), /*#__PURE__*/_react.default.createElement(_PatientEmployerRelationsDetails.default, {
    patientId: patient.id,
    relations: patientEmployerRelations,
    loading: patientEmployerRelationsLoading
  }));
};
exports.EmployerSelectorWithHistory = EmployerSelectorWithHistory;